import { Seo } from "@/components/Seo";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

const Privacy = () => {
  return (
    <>
      <Seo 
        title="Privacy Policy - AI Montclair"
        description="How AI Montclair protects your data and handles personal information."
        canonical="/privacy"
      />
      <Navbar />
      
      <div className="min-h-screen bg-background">
        <div className="container mx-auto py-16 px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none space-y-6 text-foreground">
            <p className="text-muted-foreground">
              <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
            </p>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">1. Information We Collect</h2>
              <p>
                When you use our contact forms or request a consultation, we collect personal information including:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Name</li>
                <li>Email address</li>
                <li>Company website</li>
                <li>Information about your business needs and challenges</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">2. How We Use Your Information</h2>
              <p>
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Respond to your inquiries and consultation requests</li>
                <li>Provide information about our AI automation services</li>
                <li>Send you relevant updates about our services (only with your consent)</li>
                <li>Improve our website and services</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">3. Data Protection</h2>
              <p>
                We take the security of your personal information seriously. We implement appropriate technical 
                and organizational measures to protect your data against unauthorized access, alteration, 
                disclosure, or destruction.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">4. Third-Party Services</h2>
              <p>
                We use HubSpot to manage our contact forms and customer relationships. When you submit a form, 
                your information is processed by HubSpot in accordance with their privacy policy. We do not 
                sell or share your personal information with third parties for marketing purposes.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">5. Your Rights</h2>
              <p>
                You have the right to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of any inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications at any time</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">6. Cookies</h2>
              <p>
                Our website uses cookies to improve your browsing experience and analyze site traffic. 
                You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">7. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy or how we handle your personal information, 
                please contact us through our website contact form.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold mt-8">8. Updates to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by 
                posting the new Privacy Policy on this page and updating the "Last Updated" date.
              </p>
            </section>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default Privacy;
